import Vue from 'vue'
import VTooltip from 'v-tooltip'
import VShortkey from 'vue-shortkey'
import VueCompositionAPI from '@vue/composition-api'
import VueObserveVisibility from 'vue-observe-visibility'
import AppFilters from '../vue/plugins/AppFilters'
import AppComponents from '../vue/plugins/AppComponents'

import VueToast from 'vue-toast-notification'
import VueCarusel from 'vue-carousel'
// Import one of the available themes
import 'vue-toast-notification/dist/theme-default.css'
// import 'vue-toast-notification/dist/theme-sugar.css'

import '../../sass/v-tooltip.scss'

import store from './../vue/store/index'
// import Bugsnag from '@app/js/modules/bugsnag'

// import vuetify from '../vue/plugins/vuetify'

Vue.use(VueToast, {
  position: 'top-right'
})

Vue.use(VTooltip, {
  autoHide: false,
  defaultPlacement: 'auto',
  defaultHideOnTargetClick: true,
  defaultLoadingContent: '<i class=\'fas fa-2x fa-sync-alt fa-spin\'></i>',
  defaultDelay: { show: 500, hide: 500 },
  // Default HTML template of the tooltip element
  // It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
  // Change if the classes conflict with other libraries (for example bootstrap)
  defaultTemplate: '<div class="v-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  popover: {
    // Base class (change if conflicts with other libraries)
    defaultBaseClass: 'v-tooltip v-popover'
  }
})

// const bugsnagVue = Bugsnag.getPlugin('vue')
// if (bugsnagVue !== undefined) {
//   bugsnagVue.installVueErrorHandler(Vue)
// }

Vue.use(VueObserveVisibility)
Vue.use(VShortkey)
Vue.use(VueCompositionAPI)
Vue.use(AppFilters)
Vue.use(AppComponents)
Vue.use(VueCarusel)

const VueExtended = Vue.extend({
  store
  // vuetify
})

export default VueExtended
